import { CometChat } from '@cometchat/chat-sdk-javascript';
import { useEffect, useContext } from 'react';
import { addUnreadListener, refreshUnreadCount, removeUnreadListener } from '../utility/helpers/commonFunction';
import { Context } from '../App';
import useUnreadStore from '../store/useUnreadStore';

const UNREAD_CONNECTION_LISTENER_ID = 'GLOBAL_UNREAD_CONNECTION_LISTENER';

export const useUnreadCount = () => {
    const { cometChatUser } = useContext(Context);
    const { unreadCount } = useUnreadStore();

    useEffect(() => {
        if (!cometChatUser) return;

        refreshUnreadCount();

        const listenerID = addUnreadListener(refreshUnreadCount);

        CometChat.addConnectionListener(
            UNREAD_CONNECTION_LISTENER_ID,
            new CometChat.ConnectionListener({
                onConnected: () => {
                    refreshUnreadCount();
                },
            })
        );

        return () => {
            if (listenerID) removeUnreadListener(listenerID);
            CometChat.removeConnectionListener(UNREAD_CONNECTION_LISTENER_ID);
        };
    }, [cometChatUser]);

    return { unreadCount, updateUnread: refreshUnreadCount };
};
